module.exports = __webpack_public_path__ + "img/multibanco.f1c9793c.png";